import React from "react";
import useSWR from "swr";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/Atoms";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function MgmtEmployees() {
  const { data } = useSWR("/management/employee-performance", fetcher);
  if (!data) return <Skeleton h={400}/>;

  const chartData = data.map(e => ({ name: e.employee_name?.split(" ")[0] || "Emp", resolved: e.resolved }));

  return (
    <div className="space-y-5">
      <div>
        <div className="rc-title-1">Employee Performance</div>
        <div className="rc-callout">Ticket throughput, SLA breaches and avg resolution time.</div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 rc-card overflow-x-auto" style={{ padding: 0 }}>
          <table className="w-full text-left" style={{ minWidth: 700 }}>
            <thead><tr className="rc-caption uppercase">
              <th className="py-3 px-5 whitespace-nowrap">Employee</th><th className="py-3 px-5 whitespace-nowrap">Role</th>
              <th className="py-3 px-5 text-right whitespace-nowrap">Assigned</th><th className="py-3 px-5 text-right whitespace-nowrap">Resolved</th>
              <th className="py-3 px-5 text-right whitespace-nowrap">Breaches</th><th className="py-3 px-5 text-right whitespace-nowrap">Avg Hrs</th>
            </tr></thead>
            <tbody>
              {data.map(e => (
                <tr key={e.employee_id} className="border-t border-[var(--rc-line)]">
                  <td className="py-3 px-5"><div className="rc-headline">{e.employee_name}</div><div className="rc-caption truncate max-w-[220px]">{e.email}</div></td>
                  <td className="py-3 px-5 capitalize whitespace-nowrap">{e.role_key?.replace("_", " ")}</td>
                  <td className="py-3 px-5 text-right rc-tabular whitespace-nowrap">{e.assigned}</td>
                  <td className="py-3 px-5 text-right rc-tabular whitespace-nowrap" style={{ color: "var(--rc-success)" }}>{e.resolved}</td>
                  <td className="py-3 px-5 text-right rc-tabular whitespace-nowrap" style={{ color: e.breached > 0 ? "var(--rc-destructive)" : "inherit" }}>{e.breached}</td>
                  <td className="py-3 px-5 text-right rc-tabular whitespace-nowrap">{e.avg_resolution_hrs}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="rc-card rc-card-padded">
          <div className="rc-title-3 mb-3">Tickets resolved (this period)</div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E5EA"/>
              <XAxis dataKey="name" stroke="#8E8E93" fontSize={10}/>
              <YAxis stroke="#8E8E93" fontSize={10} allowDecimals={false}/>
              <Tooltip contentStyle={{ borderRadius: 12, border: "none", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}/>
              <Bar dataKey="resolved" fill="#34C759" radius={[6, 6, 0, 0]}/>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
